/**
 * お役立ち動画：サムネイル（ファサード）→ YouTube 埋め込みの差し替え。
 *
 * 移植元: hitotoashi-brand/wp-content/themes/hitotoashi/assets/js/videos.js
 * 挙動は移植元と同じ。カスタム要素（Dawn の流儀）に載せ替えただけ。
 *
 * ★最初から iframe を置かない理由：
 *   YouTube の埋め込みは1本あたり数百KBのJSを読み、Cookie も落ちる。
 *   一覧に何本も並ぶページなので、押されるまでは静止画1枚で済ませる。
 *   押されたときだけ youtube-nocookie の iframe と差し替える。
 *
 * ★JSが動かないときは、ファサードがそのまま YouTube へのリンクとして働く
 *   （Liquid 側で href を持たせてある）。ここでは preventDefault で横取りするだけ。
 *   テーマの「JS 無しで内容が消えない」方針（sections/htt-digest.liquid のコメント）に合わせている。
 *
 * ★カスタム要素は既定 display:inline。器として使うので
 *   assets/htt-videos.css で `htt-video-facade { display: block }` を当てている。
 */
class HttVideoFacade extends HTMLElement {
  connectedCallback() {
    const facade = this.querySelector('[data-htt-video-play]');
    if (!facade) return;

    this.guardThumb(this.querySelector('img'));

    facade.addEventListener('click', (event) => {
      // 修飾キー・中クリックは「新しいタブで YouTube を開く」を尊重する。
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
        return;
      }
      event.preventDefault();
      this.play(facade);
    });
  }

  /**
   * maxresdefault が用意されていない動画があるので、失敗したら hqdefault に落とす。
   *
   * このスクリプトは defer で読むため、error が発火し終わったあとに走ることがある。
   * イベント登録だけでは取りこぼすので、「読み込み済みなのに幅が0」＝失敗、も見る。
   */
  guardThumb(img) {
    if (!img) return;

    const fallback = img.getAttribute('data-htt-video-fallback');
    if (!fallback) return;

    const swap = () => {
      // 落とし先も失敗したときに無限ループしないよう、1回だけ差し替える。
      img.removeAttribute('data-htt-video-fallback');
      img.src = fallback;
    };

    img.addEventListener('error', swap);

    if (img.complete && img.naturalWidth === 0) swap();
  }

  /** ファサードをプレイヤーに差し替える。 */
  play(facade) {
    const id = this.getAttribute('data-htt-video');
    if (!id) return;

    const frame = document.createElement('iframe');

    frame.className = 'htt-vid-card__frame';
    frame.src =
      'https://www.youtube-nocookie.com/embed/' +
      encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1';
    frame.title = this.getAttribute('data-htt-video-title') || '';
    frame.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.setAttribute('allowfullscreen', 'true');

    facade.parentNode.replaceChild(frame, facade);

    // キーボードで再生した人のフォーカスが宙に浮かないよう、プレイヤーへ移す。
    frame.setAttribute('tabindex', '-1');
    frame.focus();
  }
}

if (!customElements.get('htt-video-facade')) {
  customElements.define('htt-video-facade', HttVideoFacade);
}
